import React from "react";
import type { IconProps } from "./icon.types";

export function ChevronDown({ size = 24, ...props }: IconProps): React.ReactElement {
  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}
